var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSkincare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Body-Care-Cream--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Body Care Cream Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 9h12.11a0.51 0.51 0 0 0 0.39 -0.19c1.83 -2.29 2 -5.07 0.44 -8.26a1 1 0 0 0 -0.81 -0.55 0.91 0.91 0 0 0 -0.87 0.45c-0.79 1.23 -1.8 2.44 -4.73 2.44 -6.92 0 -7 5.56 -7 5.61A0.5 0.5 0 0 0 6 9Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 14.25H1a1 1 0 0 0 -1 1v6.25A2.5 2.5 0 0 0 2.5 24h19a2.5 2.5 0 0 0 2.5 -2.5v-6.25a1 1 0 0 0 -1 -1Zm-3 6.25a0.5 0.5 0 0 1 -0.5 0.5h-15a0.5 0.5 0 0 1 -0.5 -0.5v-2.75a0.5 0.5 0 0 1 0.5 -0.5h15a0.5 0.5 0 0 1 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26 13h17.48a0.51 0.51 0 0 0 0.4 -0.8c-0.55 -0.73 -1.41 -1.92 -2.39 -1.92H5.25c-1 0 -1.84 1.19 -2.39 1.92a0.51 0.51 0 0 0 0.4 0.8Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSkincare);
export default ForwardRef;